import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'ypf-pas-general-ui-components';
import { MdAssignment } from 'react-icons/md';
import { CgClipboard } from 'react-icons/cg';
import { AiFillInfoCircle, AiFillFileText } from 'react-icons/ai';
import { BsPlusCircle } from 'react-icons/bs';

import { postPendingAuthorizationFilesWorkReport } from '../../../../../services/serviceRequestAttachment';
import PendAuthDateFilter from '../../../../../components/PendAuthDateFilter/PendAuthDateFilter';
import useToast from '../../../../../hooks/useToast';
import ImputationObjectModal from '../../../../../components/ImputationObjectModal/ImputationObjectModal';
import useRequestDetailPermissions from '../../../../../hooks/useRequestDetailPermissions';
import { ubicationTypeEnum, assignmentTypeEnum } from '../../../../../utils/dataStatus';

import { getColumns } from './utils';
import FilesModal from './FilesModal/FilesModal';
import OiEditModal from './OiEditModal/OiEditModal';

const PteAutorizar = ({
  fetchData,
  data,
  selectedLines,
  setSelectedLines,
  authorizationError,
  setAuthorizationError,
  setIsPendingAuthorization,
  minDate,
  maxDate,
  arrayDate,
  serviceDetails
}) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [showFilesModal, setShowFilesModal] = useState(false);
  const [showOiEditModal, setShowOiEditModal] = useState(false);
  const [showOiDetailsModal, setShowOiDetailsModal] = useState(false);

  const [dataFiles, setDataFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setNewToast } = useToast();
  const isMsds = data?.isMSDS;

  const isAsds = serviceDetails?.tipoAsignacion?.id === assignmentTypeEnum.Automatica;
  const isOyM =
    (serviceDetails?.tipoUbicacion?.id !== ubicationTypeEnum.locacion &&
      serviceDetails?.tipoUbicacion?.id !== ubicationTypeEnum.pozo) ||
    !!serviceDetails?.operacion?.length;

  const { permissions } = useRequestDetailPermissions({
    notifyTo: serviceDetails?.tipoNotificacionEnum,
    isASDS: isAsds,
    isOyM
  });

  // Si No hay mensaje quiere decir que  Hay PL pendientes.(No hay otro flag) El mensaje que recibimos de BE es No quedan posiciones y líneas pendientes de autorizar
  const hasPLToAuthorize = data?.mensaje?.length === 0;
  const handleSearch = () => {
    fetchData(startDate, endDate, data);
  };

  const handleShowFilesModal = async () => {
    setShowFilesModal(true);
    setLoading(true);
    try {
      const response = await postPendingAuthorizationFilesWorkReport(data);

      setDataFiles(response);
    } catch (e) {
      setNewToast({
        type: 'ERROR',
        message: e.message ?? 'No se pudo obtener los archivos para descargar.'
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setStartDate(minDate);
    setEndDate(maxDate);
  }, [minDate, maxDate]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    setIsPendingAuthorization(true);
    // Unset authorizationError (if exists) on first render
    if (authorizationError) {
      setAuthorizationError('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getComponent = () => {
    // If has pending lines
    if (data?.lineas?.length > 0) {
      return (
        <div className="d-flex flex-column w-100">
          <div className="d-flex flex-row justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <button
                aria-label="ver-archivos"
                disabled={!data?.contieneArchivosAdjuntos}
                onClick={handleShowFilesModal}
                style={{
                  paddingLeft: '25px',
                  textAlign: 'end'
                }}
                type="button"
              >
                <AiFillFileText
                  className={`${data?.contieneArchivosAdjuntos ? 'text-primary' : ''}`}
                  size={20}
                />
              </button>
              <button
                aria-label="ver-archivos"
                className="text-primary  fw-normal"
                disabled={!data?.objetoImputacion}
                onClick={() => setShowOiEditModal(true)}
                style={{
                  paddingLeft: '15px'
                }}
                type="button"
              >
                {data?.objetoImputacion}
              </button>
              <button
                aria-label="ver-objecto-imputacion"
                className="text-primary"
                onClick={() => setShowOiDetailsModal(true)}
                style={{
                  paddingLeft: '15px'
                }}
                type="button"
              >
                <BsPlusCircle size={20} />
              </button>
              {showFilesModal && (
                <FilesModal
                  dataFiles={dataFiles}
                  hideModal={() => setShowFilesModal(false)}
                  loading={loading}
                  noFetch
                  setLoading={setLoading}
                  showModal={showFilesModal}
                />
              )}
              {showOiEditModal && (
                <OiEditModal
                  details={{ ...serviceDetails, ubicationId: data.ubicationId ?? null }}
                  fetchData={handleSearch}
                  hideModal={() => setShowOiEditModal(false)}
                  isMsds={isMsds}
                  isOyM={isOyM}
                  loading={loading}
                  permissions={permissions?.typeAndObjectImputation}
                  setLoading={setLoading}
                  showModal={showOiEditModal}
                />
              )}

              {showOiDetailsModal && (
                <ImputationObjectModal
                  assignmentType={serviceDetails?.tipoAsignacion}
                  dateEnd={endDate}
                  dateInit={startDate}
                  fromPteAuthorization
                  idSolicitud={serviceDetails?.id}
                  idUbicacion={data?.ubicationId}
                  imputationObject={data?.objetoImputacion}
                  loading={loading}
                  onHide={() => setShowOiDetailsModal(false)}
                  proveedor={serviceDetails?.proveedorAsignado?.nombre ?? serviceDetails?.proveedor}
                  requestNumber={`(${serviceDetails?.numeroContrato})   ${serviceDetails?.numero}`}
                  setLoading={setLoading}
                  show={showOiDetailsModal}
                  titleUbication={serviceDetails?.ubicacionStr ?? data?.ubicationName}
                />
              )}
            </div>
            {startDate && endDate && hasPLToAuthorize && (
              <div className="d-flex flex-row-reverse">
                <PendAuthDateFilter
                  arrayDate={arrayDate}
                  endDate={endDate}
                  handleEndDateChange={setEndDate}
                  handleSearch={handleSearch}
                  handleStartDateChange={setStartDate}
                  isMSDS={isMsds}
                  maxDate={maxDate}
                  minDate={minDate}
                  startDate={startDate}
                />
              </div>
            )}
          </div>
          <Table
            columns={getColumns(data?.lineas, selectedLines, setSelectedLines)}
            data={data?.lineas ?? []}
            pageCount={20}
            size="sm"
            titleLeft
          />
          <div className="d-flex justify-content-end pt-4">
            <p className="h5" style={{ paddingRight: '70px' }}>
              <CgClipboard /> Monto pendiente a autorizar:
              <span style={{ fontWeight: 'bold' }}> ${data?.montoPendiente || 0}</span>
            </p>
          </div>
          {authorizationError ? (
            <p
              className="text-center p-3 m-3"
              style={{ backgroundColor: '#ffefef', fontWeight: 600, color: '#e38999' }}
            >
              {authorizationError}
            </p>
          ) : (
            <p
              className="text-center p-3 m-3"
              style={{ backgroundColor: 'rgb(239,239,239)', fontWeight: 600, color: '#737373' }}
            >
              <div className="p-2 d-inline-block text-primary">
                <AiFillInfoCircle />
              </div>
              Si presiona Autorizar se enviarán los datos a SAP y no podrá modificarse
            </p>
          )}
        </div>
      );
    }

    return (
      <div className="nodata-container">
        {arrayDate?.length > 0 && hasPLToAuthorize && (
          <div className="d-flex flex-row-reverse w-100">
            <PendAuthDateFilter
              arrayDate={arrayDate}
              endDate={endDate}
              handleEndDateChange={setEndDate}
              handleSearch={handleSearch}
              handleStartDateChange={setStartDate}
              isMSDS={isMsds}
              maxDate={maxDate}
              minDate={minDate}
              startDate={startDate}
            />
          </div>
        )}
        <div className="d-flex flex-column justify-content-center align-items-center">
          <div>
            <MdAssignment size={50} />
          </div>
          <div>
            <p>
              <strong>
                {data?.mensaje
                  ? data?.mensaje
                  : 'No quedan posiciones y líneas pendientes de autorizar'}
              </strong>
            </p>
          </div>
        </div>
      </div>
    );
  };

  return getComponent();
};

export default PteAutorizar;

PteAutorizar.propTypes = {
  fetchData: PropTypes.func,
  data: PropTypes.shape({
    mensaje: PropTypes.string,
    montoPendiente: PropTypes.string,
    lineas: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        posicion: PropTypes.string,
        linea: PropTypes.string,
        cantReg: PropTypes.string,
        cantCert: PropTypes.string,
        pxQ: PropTypes.string,
        estadoCert: PropTypes.number,
        idParteTrabajoDiariosCostos: PropTypes.arrayOf(PropTypes.number)
      })
    )
  }),
  selectedLines: PropTypes.arrayOf(PropTypes.shape({})),
  setSelectedLines: PropTypes.func,
  authorizationError: PropTypes.string,
  setAuthorizationError: PropTypes.func,
  setIsPendingAuthorization: PropTypes.func
};

PteAutorizar.defaultProps = {
  fetchData: () => {},
  data: null,
  selectedLines: [],
  setSelectedLines: () => {},
  authorizationError: '',
  setAuthorizationError: () => {},
  setIsPendingAuthorization: () => {}
};
